export function injectSaga(store, { key, saga }) {
  store.sagas = store.sagas || {}
  if (store.sagas[key]) store.sagas[key].cancel()
  store.sagas[key] = store.runSaga(saga)
}

export function cancelSaga(store, key) {
  if (store.sagas && store.sagas[key]) store.sagas[key].cancel()
}



// WEBPACK FOOTER //
// ./src/routes/Button/store/sagas.js